import React from 'react';
import { FileDownloadOutlined } from '@mui/icons-material';
import './ExportButton.css';

/** Icône discrète d'export, à poser dans le header de chaque carte. */
const ExportButton = ({ onExport, title = 'Exporter', icon: Icon = FileDownloadOutlined, disabled = false }) => (
  <button
    type="button"
    className="export-btn"
    onClick={onExport}
    disabled={disabled}
    title={title}
    aria-label={title}
  >
    <Icon style={{ fontSize: 14 }} />
  </button>
);

export default ExportButton;